import { Label } from '@/shared/components/ui/label';
import { Textarea } from '@/shared/components/ui/textarea';

/** Small labelled-field primitives shared by the advisor editor tab. */
export const Field = ({
  label,
  error,
  children,
}: {
  label: string;
  error?: string;
  children: React.ReactElement<{ id?: string; 'aria-invalid'?: boolean }>;
}) => (
  <div className="space-y-1">
    <Label htmlFor={children.props.id}>{label}</Label>
    {children}
    {error && <p className="text-sm text-red-600">{error}</p>}
  </div>
);

export const ReadOnly = ({ label, value }: { label: string; value: string }) => (
  <div className="space-y-1">
    <span className="text-sm font-medium text-gray-700">{label}</span>
    <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
      {value}
    </div>
  </div>
);

export const TextAreaField = ({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
}) => {
  const id = label.replace(/\s+/g, '-').toLowerCase();

  return (
    <div className="mb-4 space-y-1 last:mb-0">
      <Label htmlFor={id}>{label}</Label>
      <Textarea id={id} value={value} onChange={(event) => onChange(event.target.value)} />
    </div>
  );
};
